import { useContext } from 'react';

import StarsWidgetContext from '@swf/core/providers/StarsWidgetContext';

export interface WidgetContext {
  widgetTargetId?: string;
}

const useWidgetAnchor = (id?: string): string => {
  const { uid } = useContext(StarsWidgetContext) || {};
  const index = (id || uid) as string;
  return `SW${index?.replace(/.*\//, '')}`;
};

export default useWidgetAnchor;
